import React from 'react';
import CloverSettings from './CloverSettings';
import SquareSettings from './SquareSettings';
// import ToastSettings from './ToastSettings';
// import LightspeedSettings from './LightspeedSettings';

const POSSpecificSettings = ({ settings, onDisconnect }) => {
  switch (settings?.provider) {
    case 'CloverV2':
      return <CloverSettings settings={settings} onDisconnect={onDisconnect} />;
    case 'square':
      return <SquareSettings onDisconnect={onDisconnect} />;
    // case 'toast':
    //   return <ToastSettings onDisconnect={onDisconnect} />;
    // case 'lightspeed':
    //   return <LightspeedSettings onDisconnect={onDisconnect} />;
    default:
      return null;
  }
};

export default POSSpecificSettings; 